import { useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
    Typography,
    FormControl,
    InputLabel,
    OutlinedInput,
    Box,
    InputAdornment,
    IconButton,
    FormHelperText
} from '@mui/material'
import moment from 'moment'
import 'moment/locale/id'
import axios from 'axios'
import apiUrl from '../../configs/constant';
import { useToast } from '../../components/ToastProvider'
import { useForm, Controller } from 'react-hook-form'
import React from 'react'
import Icon from '../icon'


interface Props {
    open: boolean
    mode: any
    data?: any
    doc_type?: any
    doc_id?: any
    onClose: () => void
}

const today = () => new Date().toISOString().split('T')[0]

const formatNumber = (value: string) => {
    const raw = value.replace(/[^0-9,]/g, '')
    const parts = raw.split(',')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return parts.join(',')
}

export default function DialogDPVendor({
    open,
    mode,
    data,
    doc_type,
    doc_id,
    onClose,
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [listVendor, setListVendor] = useState<any[]>([])
    const [selectedData, setSelectedData] = useState<any>(null)
    const [modeDialog, setModeDialog] = useState<any>(null)
    const [tgl, setTgl] = useState<string>('')
    const [listAkun, setListAkun] = useState<any[]>([])
    const [openPembayaran, setOpenPembayaran] = useState(false)
    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<any>(null)
    const [file2, setFile2] = useState<any>(null)
    const [txtFile2, setTxtFile2] = useState<any>(null)

    useEffect(() => {
        if (!open) return

        if (mode === 'edit') {
            setValue('tanggalJt', data?.tgl_jth_tempo.substring(0, 10) ?? today());
            setValue('vendor', data.vendor)
            setValue('total', formatNumber(String(data.total ?? '')))
            setValue('keterangan', data.keterangan ?? '')
            setTgl(data.tgl ?? today())
            getDetail(data.id)
            getDetailSupplier(data.pbsupplier_id)
        } else if (mode == 'add-from-list') {
            setTgl(data.tgl ?? today())
            setValue('tanggalJt', today());
            setValue('vendor', null)
            setValue('total', data?.default_dp ?? 0)
            setValue('keterangan', data?.default_dp_pesan ?? '')
        } else {
            setValue('tanggalJt', today());
            setValue('vendor', null)
            setValue('total', '')
            setValue('keterangan', '')
            setTgl(today())
        }

        getVendor(data?.pbsupplier_id)
        getAkun(data?.accakun_id)
        setModeDialog(mode)
        setSelectedData(data)

    }, [mode, data, open])

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset
    } = useForm({
        defaultValues: {
            vendor: null,
            tanggalJt: '',
            total: '',
            keterangan: '',
            image: null,
            nama_bank: '',
            nomor_bank: ''
        }
    })

    const {
        control: controlBayar,
        handleSubmit: handleSubmitBayar,
        setValue: setValueBayar,
        reset: resetBayar,
        formState: { errors: errorsBayar }
    } = useForm({
        defaultValues: {
            akun: null,
            tgl_bayar: '',
            total: '',
            image2: null
        }
    })


    const getAkun = (ids: any) => {

        // const url = apiUrl.apiUrl + '/acc/mutasi-kas/get-akun'
        let url = apiUrl.apiUrl + '/acc/dp/list-akun'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    data.forEach(element => {
                        if (element.id == ids) {
                            setValueBayar('akun', element)
                        }
                    })

                    setListAkun(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getVendor = (ids: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-vendor/get-vendor'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach(element => {
                        if (element.id == ids) {
                            setValue('vendor', element)
                        }
                    });
                    setListVendor(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetailSupplier = (id: any) => {
        let url = apiUrl.apiUrl + '/production/jasa-work-order/get-detail-supplier'

        axios
            .get(url, {
                params: {
                    pbsupplier_id: id,
                }, headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    setValue('nama_bank', data.nama_bank ?? '')
                    setValue('nomor_bank', data.nomor_bank ?? '')
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-vendor/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    console.log(data)

                    setSelectedData(data)
                    setModeDialog('edit')
                    setValueBayar('tgl_bayar', data.tgl_bayar == null ? data.tgl?.split(' ')[0] : data.tgl_bayar?.split(' ')[0])
                    setValueBayar('image2', data.link2 ?? null)
                    setValueBayar('total', data.total_bayar == 0 ? data.total : data.total_bayar)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const onSubmit = (data: any) => {

        const url =
            modeDialog === 'add' || modeDialog === 'add-from-list'
                ? apiUrl.apiUrl + '/acc/dp-vendor/store-dp'
                : apiUrl.apiUrl + '/acc/dp-vendor/update-dp/' + selectedData.id;

        const formData = new FormData();
        formData.append("pbsupplier_id", data.vendor?.id ?? null);
        formData.append("nama_supplier", data.vendor?.nama ?? '');
        formData.append("tgl_jth_tempo", data.tanggalJt);
        formData.append("total", data.total);
        formData.append("nomor_bank", data.nomor_bank);
        formData.append("nama_bank", data.nama_bank);
        formData.append("keterangan", data.keterangan);
        formData.append("image", file);
        formData.append("doc_type", doc_type ?? null);
        formData.append("doc_id", doc_id ?? null);

        axios.post(url, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            showToast(res.data.message, 'success')
            const id = res.data.id
            setModeDialog('edit')
            getDetail(id)
        })
    }

    const onSubmitPembayaran = (data: any) => {
        const payload = {
            akun_id: data.akun.id,
            tgl_bayar: data.tgl_bayar,
            total: data.total,
            image2: file2
        }

        const formData = new FormData();
        formData.append("akun_id", data.akun.id);
        formData.append("tgl_bayar", data.tgl_bayar);
        formData.append("total", data.total);
        formData.append("image2", file2);

        // console.log(payload)

        const url = apiUrl.apiUrl + '/acc/dp-vendor/penerimaan/' + selectedData.id

        axios.post(url, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            showToast(res.data.message, 'success')
            onClose()
        })
    }

    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        setFile(files)
        setTxtFile(nameFiles)
        setValue('image', files)
    }

    const hiddenFileInput2 = React.useRef<HTMLInputElement>(null)
    const handleClick2 = (event: any) => {
        if (hiddenFileInput2.current) {
            hiddenFileInput2.current.click()
        }
    }

    const handleFile2 = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        setFile2(files)
        setTxtFile2(nameFiles)
        setValueBayar('image2', files)
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>

            {/* ================= FORM DP PEMBELIAN ================= */}
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle
                    sx={{
                        textAlign: 'center',
                        fontSize: '16px',
                        fontWeight: 600,
                        py: 2
                    }}
                >
                    {modeDialog === 'add' || modeDialog === 'add-from-list' ? 'Buat DP Pembelian' : 'Edit DP Pembelian'}
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {/* Tanggal */}
                        <Grid item xs={12}>
                            <Typography>
                                Tanggal : <b>{moment(tgl).locale('id').format('DD MMMM YYYY')}</b>
                            </Typography>
                        </Grid>
                        {/* Vendor */}
                        <Grid item xs={12}>
                            <Controller
                                name="vendor"
                                control={control}
                                rules={{ required: 'Vendor wajib dipilih' }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listVendor}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama ?? ''}
                                        // onChange={(_, val) => field.onChange(val)}
                                        onChange={(_, val) => {
                                            field.onChange(val)
                                            if (val?.id) {
                                                getDetailSupplier(val.id)
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Vendor"
                                                error={!!errors.vendor}
                                                helperText={errors.vendor?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        {/* Jatuh Tempo */}
                        <Grid item xs={12}>
                            <Controller
                                name="tanggalJt"
                                control={control}
                                rules={{ required: 'Tanggal jatuh tempo wajib diisi' }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="Tanggal Jatuh Tempo"
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        error={!!errors.tanggalJt}
                                        helperText={errors.tanggalJt?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Total */}
                        <Grid item xs={12}>
                            <Controller
                                name="total"
                                control={control}
                                rules={{ required: 'Total wajib diisi' }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Total"
                                        fullWidth
                                        inputProps={{ inputMode: 'numeric' }}
                                        onChange={(e) =>
                                            field.onChange(formatNumber(e.target.value))
                                        }
                                        error={!!errors.total}
                                        helperText={errors.total?.message as string}
                                        disabled={selectedData?.id && modeDialog === 'edit' && true}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={10}>
                            <input
                                type='file'
                                ref={hiddenFileInput}
                                onChange={handleFile}
                                style={{ display: 'none' }}
                                accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx"
                            ></input>
                            <FormControl fullWidth>
                                <Controller
                                    name='image'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <>
                                            <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                            <OutlinedInput
                                                label='Foto'
                                                value={txtFile}
                                                id='input-file'
                                                type={'text'}
                                                error={Boolean(errors.image)}
                                                startAdornment={
                                                    <Box
                                                        onClick={handleClick}
                                                        onMouseDown={e => e.preventDefault()}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        <InputAdornment position='start'>
                                                            Pilih Gambar &nbsp;
                                                            <IconButton edge='start' aria-label='paperclip'>
                                                                <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    </Box>
                                                }
                                            />
                                        </>
                                    )}
                                />
                                {errors.image && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        {selectedData?.link && (
                            <Grid item xs={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() =>
                                        window.open(
                                            `${selectedData?.link}`,
                                            '_blank'
                                        )
                                    }
                                >
                                    Lihat
                                </Button>
                            </Grid>
                        )}

                        {/* Nomor Bank */}
                        <Grid item xs={6}>
                            <Controller
                                name="nomor_bank"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Nomor Rekening"
                                        type='number'
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="nama_bank"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Nama Rekening"
                                        type='text'
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        {/* Keterangan */}
                        <Grid item xs={12}>
                            <Controller
                                name="keterangan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Keterangan"
                                        multiline
                                        rows={2}
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>
                </DialogContent>

                {/* <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained" fullWidth>
                                {modeDialog === 'add' || modeDialog === 'add-from-list' ? 'SIMPAN' : 'UPDATE'}
                            </Button>
                        </Grid>
                    </Grid>
                    {selectedData?.id != null && selectedData?.tgl_bayar == null ?
                        <Grid item xs={12}>
                            <Button
                                variant="outlined"
                                color="success"
                                fullWidth
                                onClick={() => {
                                    setOpenPembayaran(true)
                                }}
                            >
                                {selectedData?.tgl_cair ? 'LIHAT' : 'BAYAR'}
                            </Button>
                        </Grid>
                        : null}
                    <Button
                        fullWidth
                        variant="contained"
                        color="inherit"
                        onClick={() => {
                            onClose()
                        }}
                    >
                        CLOSE
                    </Button>
                </DialogActions> */}
                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained" fullWidth>
                                {modeDialog === 'add' || modeDialog === 'add-from-list' ? 'SIMPAN' : 'UPDATE'}
                            </Button>
                        </Grid>

                        {selectedData?.id && modeDialog === 'edit' && (
                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    fullWidth
                                    onClick={() =>
                                        window.open(
                                            `${apiUrl.baseUrl}/acc/dp-vendor/pdf/${selectedData.id}`,
                                            '_blank'
                                        )
                                    }
                                >
                                    DOWNLOAD DOKUMEN
                                </Button>
                            </Grid>
                        )}

                        {selectedData?.id && modeDialog === 'edit' && (
                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    color="success"
                                    fullWidth
                                    onClick={() => {
                                        setOpenPembayaran(true)
                                    }}
                                >
                                    {selectedData?.tgl_bayar ? 'LIHAT PEMBAYARAN' : 'BUAT PEMBAYARAN'}
                                </Button>
                            </Grid>
                        )}

                        {selectedData?.id && modeDialog === 'edit' && (
                            <>
                                <Grid item xs={6}>
                                    <Button
                                        variant="outlined"
                                        color="success"
                                        fullWidth
                                        onClick={() => {
                                            window.open(
                                                `${apiUrl.baseUrl}/acc/mutasi-kas-bank/pdf/${selectedData?.accmutasi_id}`,
                                                '_blank'
                                            )
                                        }}
                                    >
                                        CETAK BKK A5
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="outlined"
                                        color="success"
                                        fullWidth
                                        onClick={() => {
                                            window.open(
                                                `${apiUrl.baseUrl}/acc/mutasi-kas-bank/pdf-a6/${selectedData?.accmutasi_id}`,
                                                '_blank'
                                            )
                                        }}
                                    >
                                        CETAK BKK A6
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </DialogActions>
            </form>


            {/* ================= FORM PEMBAYARAN ================= */}
            {selectedData?.tgl_bayar != null || openPembayaran ?
                <form onSubmit={handleSubmitBayar(onSubmitPembayaran)}>
                    <DialogTitle
                        sx={{
                            textAlign: 'center',
                            fontSize: '16px',
                            fontWeight: 600,
                            py: 2
                        }}
                    >
                        {selectedData?.tgl_bayar
                            ? 'Lihat Pembayaran'
                            : 'Buat Pembayaran'}
                    </DialogTitle>

                    <DialogContent dividers>
                        <Grid container spacing={2} sx={{ mt: 1 }}>

                            {/* AKUN */}
                            <Grid item xs={12}>
                                <Controller
                                    name="akun"
                                    control={controlBayar}
                                    rules={{ required: 'Akun wajib dipilih' }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            value={field.value || null}
                                            options={listAkun}
                                            isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                            getOptionLabel={(o) => o?.nama ?? ''}
                                            onChange={(_, val) => field.onChange(val)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Akun Pembayaran"
                                                    error={!!errorsBayar.akun}
                                                    helperText={errorsBayar.akun?.message as string}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* TANGGAL BAYAR */}
                            <Grid item xs={12}>
                                <Controller
                                    name="tgl_bayar"
                                    control={controlBayar}
                                    rules={{ required: 'Tanggal bayar wajib diisi' }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            type="date"
                                            label="Tanggal Bayar"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={!!errorsBayar.tgl_bayar}
                                            helperText={errorsBayar.tgl_bayar?.message as string}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={10}>
                                <input
                                    type='file'
                                    ref={hiddenFileInput2}
                                    onChange={handleFile2}
                                    style={{ display: 'none' }}
                                    accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx"
                                ></input>
                                <FormControl fullWidth>
                                    <Controller
                                        name='image2'
                                        control={controlBayar}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                                <OutlinedInput
                                                    label='Foto'
                                                    value={txtFile2}
                                                    id='input-file'
                                                    type={'text'}
                                                    error={Boolean(errorsBayar.image2)}
                                                    startAdornment={
                                                        <Box
                                                            onClick={handleClick2}
                                                            onMouseDown={e => e.preventDefault()}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <InputAdornment position='start'>
                                                                Pilih Gambar &nbsp;
                                                                <IconButton edge='start' aria-label='paperclip'>
                                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Box>
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                    {errorsBayar.image2 && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {selectedData?.link2 && (
                                <Grid item xs={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() =>
                                            window.open(
                                                `${selectedData?.link2}`,
                                                '_blank'
                                            )
                                        }
                                    >
                                        Lihat
                                    </Button>
                                </Grid>
                            )}

                            {/* TOTAL */}
                            <Grid item xs={12}>
                                <Controller
                                    name="total"
                                    control={controlBayar}
                                    rules={{ required: 'Total wajib diisi' }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Total"
                                            fullWidth
                                            inputProps={{ inputMode: 'numeric' }}
                                            onChange={(e) =>
                                                field.onChange(formatNumber(e.target.value))
                                            }
                                            error={!!errorsBayar.total}
                                            helperText={errorsBayar.total?.message as string}
                                        />
                                    )}
                                />
                            </Grid>

                        </Grid>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="success"
                        >
                            SIMPAN
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            color="inherit"
                            onClick={() => {
                                onClose()
                            }}
                        >
                            CLOSE
                        </Button>
                    </DialogActions>
                </form> : null}

        </Dialog>

    )
}
